import React from 'react';
import styled from 'styled-components';

import type { Mode } from '@splunk/dashboard-types';

import { variables } from '@splunk/themes';
import { Title } from './Title';

const TitleContainerRoot = styled.div`
    display: flex;
    align-items: baseline;
    min-height: ${variables.inputHeight};
    box-sizing: inherit;
`;

const TitleSlot = styled.div<{ $mode: Mode }>`
    flex: ${({ $mode }) => ($mode === 'edit' ? '1 1 auto' : '0 1 auto')};
    min-width: 0;
    display: flex;
`;

const AccessorySlot = styled.div`
    flex: 0 0 auto;
    display: flex;
    align-items: baseline;
    margin-inline-start: -${variables.spacingSmall};
`;

export interface TitleContainerProps {
    children?: React.ReactNode;
    isExpanded: boolean;
    mode: Mode;
    onValueChange: (value?: string) => void;
    titleRef?: React.Ref<HTMLElement>;
    value?: string;
}

export const TitleContainer = ({
    children,
    isExpanded,
    mode,
    onValueChange,
    titleRef,
    value,
}: TitleContainerProps): JSX.Element | null => {
    if (mode === 'view' && !value) {
        return null;
    }

    return (
        <TitleContainerRoot data-test="dashboard-header-title">
            <TitleSlot $mode={mode}>
                <Title
                    ref={titleRef}
                    isExpanded={isExpanded}
                    mode={mode}
                    onValueChange={onValueChange}
                    value={value}
                />
            </TitleSlot>
            {mode === 'view' && children ? (
                <AccessorySlot>{children}</AccessorySlot>
            ) : null}
        </TitleContainerRoot>
    );
};
